module.exports = __webpack_public_path__ + "static/img/bg_user_header.7b016a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/user/bg_user_header.jpg
// module id = eyBK
// module chunks = 0